import { extractBooleanProperty, extractProperty } from '@/utils/extract-property';
import { ElementFragment, ElementSortField } from '@/core/graphql/graphql';
import { Column, ColumnType } from '@/shared/components/table/table.model';
import { TemplateRef } from '@angular/core';

export const ELEMENT_COLUMNS: (elementTemplateReference: TemplateRef<any>) =>
Column<ElementFragment>[] = (template: TemplateRef<any>) => [
  {
    columnId: "id",
    caption: "ID",
    fieldSelector: (element: ElementFragment) => extractProperty(element.id),
  },
  {
    columnId: "owner",
    caption: "Owner",
    fieldSelector: (element: ElementFragment) => extractProperty(element.owner?.username),
  },
  {
    columnId: "type",
    caption: "Type",
    fieldSelector: (element: ElementFragment) => extractProperty(element.type),
  },
  {
    columnId: "createdAt",
    caption: "Created",
    fieldSelector: (element: ElementFragment) => extractProperty(element.createdAt),
    sortable: true,
    type: ColumnType.Date,
  },
  {
    columnId: "isFeatured",
    caption: "Is Featured",
    fieldSelector: (element: ElementFragment) => extractBooleanProperty(element.isFeatured),
  },
  {
    columnId: "isOnboarding",
    caption: "Is Onboarding",
    fieldSelector: (element: ElementFragment) => extractBooleanProperty(element.isOnboarding),
  },
  {
    columnId: "preview",
    caption: "Preview",
    fieldSelector: (element: ElementFragment) => extractProperty(element),
    type: ColumnType.Template,
    template: template,
  },
];

export const ELEMENT_FILTER_DESCRIPTION: string = 'Show private';

export const ELEMENT_SORT_FIELD = (option: string): ElementSortField => {
  switch (option) {
  case "createdAt":
    return ElementSortField.CreatedAt;
  default:
    throw new Error('Unsupported sorting field');
  }
};
